import type { FC, ReactNode } from 'react'

import { Check } from 'lucide-react'
import DemoForm from '@/components/landing/demo-form'
import SectionHeading from '@/components/landing/section-heading'
import { siteConfig } from '@/constants/site'
import { DEMO_POINTS } from '@/constants/landing'

const DemoSection: FC = (): ReactNode => {
    return (
        <section id='demo' aria-labelledby='demo-title' className='relative isolate overflow-hidden bg-brand-950 py-20 text-white sm:py-28'>
            <div aria-hidden='true' className='pointer-events-none absolute inset-0 -z-10'>
                <div className='absolute -left-48 -top-24 size-[34rem] rounded-full bg-[radial-gradient(closest-side,rgb(53_102_219/0.5),transparent)]' />
                <div className='absolute -bottom-40 -right-40 size-[30rem] rounded-full bg-[radial-gradient(closest-side,rgb(95_137_230/0.28),transparent)]' />
                <div className='absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgb(255_255_255/0.07)_1px,transparent_0)] [background-size:22px_22px] [mask-image:radial-gradient(ellipse_80%_70%_at_30%_40%,black,transparent)]' />
            </div>

            <div className='mx-auto grid max-w-6xl gap-12 px-5 sm:px-6 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:gap-16 lg:px-8'>
                <div>
                    <SectionHeading
                        id='demo-title'
                        tone='light'
                        eyebrow="Book a demo"
                        title="See your business at a glance."
                        description="Tell us a little about your business and we'll get in touch to set up a walkthrough of Elenix."
                    />

                    <ul className='mt-8 space-y-4'>
                        {DEMO_POINTS.map(point => (
                            <li key={point} className='flex items-center gap-3 text-base text-white/85'>
                                <span className='grid size-6 shrink-0 place-items-center rounded-full bg-white/10 text-brand-200 ring-1 ring-white/15'>
                                    <Check className='size-3.5' strokeWidth={3} />
                                </span>

                                {point}
                            </li>
                        ))}
                    </ul>

                    <p className='mt-10 text-sm text-white/70'>
                        Already using Elenix?{' '}

                        <a
                            href={siteConfig.appUrl}
                            className='rounded font-semibold text-white underline decoration-white/40 underline-offset-4 outline-none transition-colors hover:decoration-white focus-visible:ring-3 focus-visible:ring-white/40'
                        >
                            Sign in here
                        </a>
                    </p>
                </div>

                <DemoForm />
            </div>
        </section>
    )
}

export default DemoSection
